import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=455a00ba&scoped=true"
import script from "./sideNav.vue?vue&type=script&lang=js"
export * from "./sideNav.vue?vue&type=script&lang=js"
import style0 from "./sideNav.vue?vue&type=style&index=0&id=455a00ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.105.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a00ba",
  null
  
)

export default component.exports